/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import React from 'react';

import LayerAutoFocus from 'components/mixins/LayerAutoFocus';
import Layer from 'components/Layer.jsx';
import createChainedFunction from 'utils/createChainedFunction';

import './styles/Menu.scss';

const Menu = React.createClass({
  propTypes: {
    hideOnSelect: React.PropTypes.bool,
    onSelect: React.PropTypes.func,
    selectedKey: React.PropTypes.string,
    horizontal: React.PropTypes.bool,
    title: React.PropTypes.string,
  },

  mixins: [
    LayerAutoFocus,
  ],

  getDefaultProps() {
    return {
      hideOnSelect: true,
      selectedKey: '',
      horizontal: false,
    };
  },

  handleMenuItemSelect(key: string) {
    if (this.props.onSelect) {
      this.props.onSelect(key);
    }
  },

  renderMenuItem(menuItem: React$Element<*>) {
    if (menuItem === null) {
      return null;
    }

    const key = menuItem.props.menuKey || menuItem.key;
    const onClick = this.props.hideOnSelect
      ? createChainedFunction(menuItem.props.onClick, this.props.onRequestHide)
      : menuItem.props.onClick;
    return React.cloneElement(menuItem, {
      ref: menuItem.ref,
      menuKey: key,
      onClick,
      onSelect: createChainedFunction(menuItem.props.onSelect, this.handleMenuItemSelect),
      selected: this.props.selectedKey ? this.props.selectedKey === key : null,
    });
  },

  renderTitle() {
    const { title } = this.props;
    if (!title) {
      return null;
    }
    return <h2 className="Menu-title">{title}</h2>;
  },

  render() {
    return (
      <Layer
        propagateOutsideClicks={false}
        {...this.props}
        className={cx({
          Menu: true,
          'Menu--horizontal': this.props.horizontal,
        }, this.props.className)}>
        <div className="Menu-dropdown">
          {this.renderTitle()}
          <ul className="Menu-list">
            {React.Children.map(this.props.children, this.renderMenuItem)}
          </ul>
        </div>
      </Layer>
    );
  },
});

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.jsx